/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'

export type ChildIconProps = {
  size: number
  imageUrl?: string | null
}

export const ChildIcon = ({ size, imageUrl }: ChildIconProps) => {
  const noImageStyle = css`
    color: #000;
    background: #e6eaeb;
    text-align: center;
  `

  const style = css`
    width: ${size}px;
    height: ${size}px;
    background: no-repeat center;
    background-size: cover;
    border-radius: 50%;
    background-image: url(${imageUrl});

    ${!imageUrl && noImageStyle}
  `

  return <div css={style}></div>
}

// <% if user_child.image.present? %>
//   <div class="<%= class_name %>" style="background-image:url(<%= user_child.wrapper_image_url %>);">
//   </div>
// <% else %>
//   <div class="<%= class_name %> -noImage">
//     <%= user_child.short_first_name %>
//   </div>
// <% end %>
